import { StepBack } from "lucide-react";
import { Button } from "../ui/button";
import { router } from "@inertiajs/react";

export const FormHeader = () => {
    return (
        <header className="border-b border-border bg-card">
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                <div className="flex items-center gap-4">
                    <Button
                        variant="outline"
                        onClick={() => router.visit("/")}
                        className="gap-2 hover:cursor-pointer"
                    >
                        <StepBack />
                    </Button>
                    <h1 className="font-serif text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
                        Formularz
                    </h1>
                </div>
            </div>
        </header>
    );
}